<ng-container *ngIf="!isLoading; else loading">
  <div class="container">
    <div>
      <div class="row">
        <div class="col-md-10">
          <h2 class="title-header d-flex align-items-center">Argus</h2>           
          <div class="scrollspy-example scrollspy-container">  
            <div *ngIf="(argusViewModel.Common?.ErrorMessages?.length ?? 0) > 0 || (argusViewModel.Common?.WarningMessages?.length ?? 0 )>0" class="form-section col-md-11">
              <div *ngIf="(argusViewModel.Common?.ErrorMessages?.length ?? 0 )>0" class="error-box">
                <h4>Errors:</h4>
                <ul>
                  <li *ngFor="let item of argusViewModel.Common?.ErrorMessages">
                    <span>❌ {{ item.message }}</span>
                  </li>
                </ul>
              </div>
              <div *ngIf="(argusViewModel.Common?.WarningMessages?.length ?? 0) >0" class="warning-box">
                <h4>Warnings:</h4>
                <ul>
                  <li *ngFor="let item of argusViewModel.Common?.WarningMessages">
                    <span>⚠️ {{ item.message }}</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div *ngIf="(argusViewModel.Common?.ErrorMessages?.length ?? -1) === 0" >
            <!-- Subject Property Details -->
            <section mdbScrollspyElement="scrollspy" id="Property-Overview">
              <div class="form-section col-md-11">
                <div class="d-flex flex-wrap gap-2">
                  <div class="col-md-5">
                    <label class="form-label">Portfolio Name</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">{{argusViewModel.PropertyOverview?.PortfolioName}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Scenario Name</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">{{argusViewModel.PropertyOverview?.ScenarioName}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Property Id</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.PropertyOverview?.PropertyId}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Property Name</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.PropertyOverview?.PropertyName}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Property Type</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.PropertyOverview?.PropertyType}}
                    </p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">External Id</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.PropertyOverview?.ExternalId}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Status</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">{{argusViewModel.PropertyOverview?.Status}}</p>
                  </div>
                </div>
              </div>
            </section>
  
            <!-- Subject Property Location -->
            <section mdbScrollspyElement="scrollspy" id="Location-Info">
              <div class="form-section col-md-11">
                <h4 class="form-header"><i class="fas fa-map-marker-alt fa-fw me-2"></i>Subject Property Location</h4>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <div class="col-md-5">
                    <label class="form-label">Property Name</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.LocationInfo?.PropertyName}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Address</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.LocationInfo?.Address}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">City</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.LocationInfo?.City}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">State</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.LocationInfo?.State}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Zipcode</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.LocationInfo?.Zipcode}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Country</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.LocationInfo?.Country}}</p>
                  </div>
                </div>
              </div>
            </section>
  
            <!-- Analysis-->
            <section mdbScrollspyElement="scrollspy" id="Analysis">
              <div class="form-section col-md-11">
                <h4 class="form-header">Analysis</h4>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <div class="col-md-5">
                    <label class="form-label">Analysis Begin Date</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel?.Analysis?.AnalysisBeginDate | date:
                      'M/d/yy'}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Analysis End Date</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel?.Analysis?.AnalysisEndDate | date:
                      'M/d/yy'}}</p>
                  </div>
                </div>
              </div>
            </section>
  
            <!-- Improvement Information -->
            <section mdbScrollspyElement="scrollspy" id="Improvement-Info">
              <div class="form-section col-md-11">
                <h4 class="form-header">
                  <i class="fas fa-building fa-fw me-2"></i>Improvement Information
                </h4>
                <div class="d-flex flex-wrap gap-2">
                  <div class="col-md-5">
                    <label class="form-label">Building Area</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel?.ImprovementInfo?.BuildingArea
                      | number}}</p>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Vacancy (%)</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel?.ImprovementInfo?.VacancyPercentage | percent:'1.2-2'}}</p>
                  </div>
                </div>
              </div>
            </section>
  
            <!-- Cashflow -->
            <section mdbScrollspyElement="scrollspy" id="Cashflow">
              <div class="form-section col-md-11">
                <h4 class="form-header">
                  <i class="fas fa-chart-line fa-fw me-2"></i>Cash Flow
                </h4>    
                <div class="d-flex flex-wrap gap-2 mt-2">
  
                  <!-- WALE (Area) -->
                  <div class="col-md-5">
                    <label class="form-label">WALE (Area)</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.CashFlow?.WALE_Area }}</p>
                  </div>

                  <!-- WALE (Rent) -->
                  <div class="col-md-5">
                    <label class="form-label">WALE (Rent)</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.CashFlow?.WALE_Rent}}</p>
                  </div>

                   <!-- WALT -->
                   <div class="col-md-5">
                    <label class="form-label">WALT</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.CashFlow?.WALT}}</p>
                  </div>
                 
                </div>            
                <div [class]="themeClass" class="grid">
                  <h4><span><i class="fas fa-money-bill-wave fa-fw me-2"></i>Rent Roll for WALT</span></h4>
                  <div class="d-flex flex-wrap gap-2">
                    <ag-grid-angular class="grid" [columnDefs]="argusViewModel.CashFlow?.RentRollforWALT?.ColumnDefs" [rowData]="argusViewModel.CashFlow?.RentRollforWALT?.RowData"
                      domLayout="autoHeight" [rowHeight]="20" [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                  </div>
                </div>
                <!-- Extra Fields with Prior and Delta -->
                <div class="d-flex flex-wrap gap-2 mt-2">
  
                  <!-- Collection Loss (%) -->
                  <div class="col-md-5">
                    <label class="form-label">Collection Loss (%)</label>
                    <p class="form-control-plaintext fs-7 fw-semibold">
                      {{argusViewModel.CashFlow?.CollectionLoss | percent:'1.2-2'}}</p>
                  </div>
                 
                </div>
                <div [class]="themeClass" class="grid">
                  <h4><span><i class="fas fa-money-bill-wave fa-fw me-2"></i>Cash Flow Items</span></h4>
                  <div class="d-flex flex-wrap gap-2">
                    <ag-grid-angular class="grid" style="height: 200px;" [columnDefs]="argusViewModel.CashFlow?.NetOperatingIncome?.ColumnDefs"
                      [rowData]="argusViewModel.CashFlow?.NetOperatingIncome?.RowData" [rowHeight]="20" [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </section>         
  
            <!-- Assumptions-->
            <section mdbScrollspyElement="scrollspy" id="Assumptions">
              <div class="form-section col-md-11">
                <h4 class="form-header"><i class="fas fa-cogs fa-fw me-2"></i>Assumptions</h4>
                <div [class]="themeClass" class="grid">
                  <h4><span><i class="fas fa-money-bill-wave fa-fw me-2"></i>Market Inflation Rate</span></h4>
                  <div class="d-flex flex-wrap gap-2">
                    <ag-grid-angular class="grid" [columnDefs]="argusViewModel?.Assumptions?.MarketInflationRate?.ColumnDefs"
                      [rowData]="argusViewModel?.Assumptions?.MarketInflationRate?.RowData" domLayout="autoHeight" [rowHeight]="20"
                      [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                  </div>
                </div>
                <div [class]="themeClass" class="grid">
                  <h4><span><i class="fas fa-money-bill-wave fa-fw me-2"></i>Expense Inflation Rate</span></h4>
                  <div class="d-flex flex-wrap gap-2">
                    <ag-grid-angular class="grid" [columnDefs]="argusViewModel?.Assumptions?.ExpenseInflationRate?.ColumnDefs"
                      [rowData]="argusViewModel?.Assumptions?.ExpenseInflationRate?.RowData" domLayout="autoHeight" [rowHeight]="20"
                      [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </section>
  
            <!-- Lease Expirations (New) -->
            <section mdbScrollspyElement="scrollspy" id="Lease-Expirations">
              <div class="form-section col-md-11">
                <h4 class="form-header"><i class="fas fa-calendar-alt fa-fw me-2"></i>Lease Expirations</h4>
                <div [class]="themeClass" class="grid">
                  <div class="d-flex flex-wrap gap-2">
                    <ag-grid-angular class="grid" [columnDefs]="argusViewModel.LeaseExpirations?.ColumnDefs" [rowData]="argusViewModel.LeaseExpirations?.RowData"
                      [rowHeight]="20" [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </section>

            <!-- Leasing Assumptions -->
            <section mdbScrollspyElement="scrollspy" id="Leasing-Assumptions">
              <div class="form-section col-md-11">
                <h4 class="form-header"><i class="fas fa-calendar-alt fa-fw me-2"></i>Leasing Assumptions</h4>
                <div [class]="themeClass" class="grid">
                  <div class="d-flex flex-wrap gap-2">
                    <ag-grid-angular class="grid" [columnDefs]="argusViewModel.LeasingAssumptions?.ColumnDefs"
                      [rowData]="argusViewModel.LeasingAssumptions?.RowData" domLayout="autoHeight" [rowHeight]="20"
                      [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </section>
  
            <!-- Contract Month Rent -->
            <section mdbScrollspyElement="scrollspy" id="Contract-Month-Rent">
              <div class="form-section col-md-11">
                <h4 class="form-header"><i class="fas fa-calendar-alt fa-fw me-2"></i>Contract Month Rent</h4>
                <div [class]="themeClass" class="grid">
                  <div class="d-flex flex-wrap gap-2">
                    <ag-grid-angular class="grid" [columnDefs]="argusViewModel.ContractMonthRent?.ColumnDefs"
                      [rowData]="argusViewModel.ContractMonthRent?.RowData" domLayout="autoHeight" [rowHeight]="20"
                      [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </section>
  
            <!-- Valuation Summary -->
            <section mdbScrollspyElement="scrollspy" id="Valuation-Summary">
              <div class="form-section col-md-11">
                <h4 class="form-header">
                  <i class="fas fa-balance-scale fa-fw me-2"></i>Valuation Summary
                </h4>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <div class="col-md-5">
                    <label class="form-label">Holding Period</label>
                    <div class="input-group input-group-sm">
                      <p class="form-control-plaintext fs-7 fw-semibold">{{argusViewModel.ValuationSummary?.HoldingPeriod}}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Capitalization Rate</label>
                    <div class="input-group input-group-sm">
                      <p *ngIf="argusResponse?.propertyResalesResponseModel?.resales[0].calcMethodBasis==0"
                        class="form-control-plaintext fs-7 fw-semibold">
                        {{argusViewModel.ValuationSummary?.CapitalizationRate | percent:'1.2-2'}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>  
          </div>            
          </div>
        </div>
        <div class="col-md-2">
          <div id="scrollspy" class="sticky-top mt-5">
            <ul mdbScrollspy="scrollspy" class="nav flex-column nav-pills menu-sidebar">
              <li class="nav-item" *ngFor="let section of sectionList">
                <a [mdbScrollspyLink]="section.id" [scrollIntoView]="true"
                  class="nav-link d-flex justify-content-between align-items-center">
                  <span>{{ section.label }}</span>                  
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loading>
  <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100vh;">
    <div class="spinner-grow text-danger" role="status">
      <span role="status" aria-hidden="true"></span>
    </div>
  </div>
</ng-template>